// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.DataConnectorItem.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import Input from 'share/components/controls/Izenda.Input';
import TextHighLight from 'share/components/controls/Izenda.TextHighLight';

@observer
export default class DataConnectorItem extends Component {

  render() {
    const { props: {dataConnector, workspaceDetail} } = this;

    const onChange = (event) => {
      dataConnector.copyDataConnector = event.target.checked;
      workspaceDetail.markDirty();
    };

    const name = String.format('[{0}] {1}', dataConnector.serverTypeName, dataConnector.name);

    return (
    <label>
      <span style={{marginRight: '5px'}}>
        <Input
          className="izenda-CustomCheckBox"
          type="checkbox"
          checked={dataConnector.copyDataConnector}
          value={dataConnector.id}
          onChange={onChange}
        />
      </span>
      <TextHighLight highlight={workspaceDetail.dataConnectorFilterText} text={name} />
    </label>
  );
  }
}


// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/CopyManagement/WorkspaceDetail/SourceDestination/DataConnector/Izenda.DataConnectorItem.jsx